import Page     from '@app/templates/vuejs/pages/TagPage'
import factory  from '@core/vuejs/services/client.factory.service'
import { getStore } from '@core/vuejs/js/store'
import {registerCommonsComponents} from '@app/assets/js/vue/components/partials/commons'
import {registerArticleComponents} from '@app/assets/js/vue/components/partials/articles'

const componentsToRegister = [registerCommonsComponents, registerArticleComponents]

const bundle = factory.createApp(Page, '#app', componentsToRegister, getStore())

export default bundle